import { AxiosResponse } from 'axios';

import {
  ApiRes,
  LoginReq,
  LoginRes,
  LogoutReq,
  PasswordReq,
  RefreshReq,
  RefreshRes,
  RegisterReq,
  StatusRes,
} from '../../types/Auth/types';
import { apiRequest } from '../Utils/apiClient';
import axiosInstance from '../Utils/interceptors';
import { LOGIN, LOGOUT, RECOVERYPASS, REFRESH, REGISTER } from '../Utils/constants';

const login = (body: LoginReq) => apiRequest<LoginRes>('post', LOGIN, body);

const logout = (body: LogoutReq): Promise<ApiRes> => apiRequest<void>('post', LOGOUT, body);

const register = (body: RegisterReq) => apiRequest<StatusRes>('post', REGISTER, body);

const password = (body: PasswordReq) => apiRequest<boolean>('post', RECOVERYPASS, body);

const refresh = async ({
  refreshToken,
}: RefreshReq): Promise<{ ok: boolean; data?: RefreshRes }> => {
  try {
    const { data }: AxiosResponse<RefreshRes> = await axiosInstance.post(REFRESH, {
      refresh_token: refreshToken,
    });
    return { ok: true, data };
  } catch (e) {
    console.error(e);
    return { ok: false };
  }
};

export { login, logout, register, password, refresh };
